import { render, staticRenderFns } from "./PlayersList.vue?vue&type=template&id=484a712b&scoped=true&"
import script from "./PlayersList.vue?vue&type=script&lang=js&"
export * from "./PlayersList.vue?vue&type=script&lang=js&"
import style0 from "./PlayersList.vue?vue&type=style&index=0&id=484a712b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a712b",
  null
  
)

export default component.exports